const editOrViewCheck = permissionStrings => {
  switch (permissionStrings) {
    case 'view':
    case 'readonly': {
      return 'view'
    }
    case 'operator':
    case 'admin': {
      return 'edit'
    }
    default: {
      return 'view'
    }
  }
}

export default editOrViewCheck
